import { render, staticRenderFns } from "./OrderTotals.vue?vue&type=template&id=a43e7328&scoped=true&"
import script from "./OrderTotals.vue?vue&type=script&lang=js&"
export * from "./OrderTotals.vue?vue&type=script&lang=js&"
import style0 from "./OrderTotals.vue?vue&type=style&index=0&id=a43e7328&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43e7328",
  null
  
)

export default component.exports